<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="box">
            <v-card-title class="headline font-weight-bold"
                style="white-space: normal; word-break: normal; line-height: 1.4;">Faculty Performance
                Report</v-card-title>
            <v-card-text>
                <v-row justify="center">
                    <v-col cols="12" sm="6" md="3">
                        <v-autocomplete rounded required v-model="selected_ay" :items="ay_list" item-text="ay"
                            :loading="onload_loader" item-value="id" outlined @change="onChangeAy()">
                            <template #label>
                                Academic year <span style="color: red">*</span>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-autocomplete rounded required v-model="selected_dept" :items="department_list"
                            item-text="name" item-value="id" outlined @change="getDesignation()">
                            <template #label>
                                Department <span style="color: red">*</span>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-autocomplete rounded required v-model="selected_designation" :items="designation_list"
                            item-text="name" item-value="id" outlined @change="getSection(); getInstructors()">
                            <template #label>
                                Designation <span style="color: red">*</span>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="3"
                      v-if="selected_designation !== '' && selected_designation !== null && status_list.length > 0">
                        <v-autocomplete rounded v-model="selected_status" :items="status_list"
                            item-text="name" item-value="id" outlined @change="selected_section=null">
                            <template #label>
                                Status
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="3"
                        v-if="selected_designation !== '' && selected_designation !== null && section_list.length > 0">
                        <v-autocomplete rounded v-model="selected_section" :items="section_list"
                            item-text="name" item-value="id" outlined @change="getInstructors()">
                            <template #label>
                                Section
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" v-show="Array.isArray(inst_list) && inst_list.length > 0">
                        <v-expand-x-transition>
                            <v-autocomplete rounded multiple required v-model="selected_inst" :items="inst_list"
                                item-text="name" item-value="id" outlined>
                                <template #label>
                                    Employee <span style="color: red">*</span>
                                </template>
                                <template v-slot:selection="{ item, index }">
                                    <v-chip v-if="index === 0">
                                        <span>{{ item.name }}</span>
                                    </v-chip>
                                    <span v-if="index === 1" class="grey--text text-caption">
                                        (+{{ selected_inst.length - 1 }} others)
                                    </span>
                                </template>
                                <template v-slot:prepend-item>
                                    <v-list-item @mousedown.prevent>
                                        <v-list-item-action>
                                            <v-checkbox v-model="selected_all_employee" @change="toggle_teacher()">
                                                <template #label><span class="ml-8">Select All</span>
                                                </template>
                                            </v-checkbox>
                                        </v-list-item-action>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>
                            </v-autocomplete>
                        </v-expand-x-transition>
                    </v-col>

                    <v-col cols="12" sm="4" md="2" class="mt-2" align="center">
                        <v-btn color="primary" :loading="loader" @click="fetchReport">Fetch Report</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card class="box" v-if="Array.isArray(table_data) && table_data.length > 0">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Faculty Performance Report</v-toolbar-title>
                <v-divider class="mx-4 divider" color="white" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-btn color="error" class="mr-2" dark small @click="generateAppraisalPdf">
                    <v-icon small left>mdi mdi-file-pdf-box</v-icon>
                    Download PDF
                </v-btn>
                <v-btn color="green" dark small @click="exportToExcel">
                    <v-icon small left>mdi-download</v-icon>
                    Export to Excel
                </v-btn>
            </v-toolbar>
            <div class="px-4 pt-4 pb-4">
                <v-text-field v-model="search" placeholder="Search by Employee Name or Code..."
                    append-icon="mdi-magnify" dense outlined hide-details></v-text-field>
            </div>
            <template>
                <v-simple-table class="teacher-appraisal-table">
                    <tr>
                        <th>Employee Code</th>
                        <th>Employee Name</th>
                        <th>Department</th>
                        <th>Section</th>
                        <th>Designation</th>
                        <th>Performance Measurement Score <br>
                            <small>(Average of Level 2 & Level 3)</small>
                        </th>
                        <th v-for="(item, index) in appraisalEvaluationParameter_list.filter(x => x.id != 14 && x.id != 19)" :key="index">
                            {{ item.name }}
                        </th>
                        <th>Credit</th>
                        <th>Total Score</th>
                        <th rowspan="2">Percentage</th>
                    </tr>
                    <tbody>
                        <tr v-for="(item, index) in paginatedTableData" :key="index">
                            <td>{{ item.employee_code }}</td>
                            <td>{{ item.employee_name }}</td>
                            <td>{{ item.department }}</td>
                            <td>{{ item.section }}</td>
                            <td>{{ item.designation }}</td>
                            <td>{{ item.performanceMeasurementScore || "-"}} / {{ total_marks_by_type }}</td>

                            <td v-for="(param, idx) in appraisalEvaluationParameter_list.filter(x => x.id != 14 && x.id != 19)" :key="'param-' + idx">
                                {{
                                    (item.facultyAppraisalOtherScore_list.find(score => score.id === param.id) ||
                                        {}).obtained_marks || '-'
                                }} / {{
                                    (item.facultyAppraisalOtherScore_list.find(score => score.id === param.id) ||
                                        {}).max_marks || '-'
                                }}
                            </td>
                            <td>
                                <span
                                    v-if="Array.isArray(item.FacultyAppraisalCreditMarks) && item.FacultyAppraisalCreditMarks.length > 0">
                                    {{ item.FacultyAppraisalCreditMarks[0] }} / {{ item.FacultyAppraisalCreditMarks[1]
                                    }}</span><span v-else>0</span>
                            </td>
                            <td>{{ item.total_score.toFixed(2) }} / {{ item.out_of_mark_total }}</td>
                            <td>{{ item.percentage.toFixed(2) }}</td>
                        </tr>

                    </tbody>
                </v-simple-table>
                <div class="d-flex justify-end ma-2 pt-2">
                    <v-btn small outlined :disabled="currentPage === 1" @click="currentPage--">
                        << </v-btn>
                            <span class="mx-2">Page {{ currentPage }} of {{ totalPages }}</span>
                            <v-btn small outlined :disabled="currentPage === totalPages" @click="currentPage++"> >>
                            </v-btn>
                </div>
            </template>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
import * as XLSX from 'xlsx'; // If you use SheetJS for export
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
    data() {
        return {
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            department_list: [],
            section_list: [],
            designation_list: [],
            ay_list: [],
            selected_ay: "",
            selected_dept: "",
            selected_section: "",
            selected_designation: "",
            selected_inst: [],
            selected_status:"",
            inst_list: [],
            selected_all_employee: false,
            appraisalEvaluationParameter_list: [],
            table_data: [],
            ay_id: "",
            organization_id: "",
            loader: false,
            total_marks_by_type: '',
            out_of_mark_total: '',
            search: '',
            currentPage: 1,
            itemsPerPage: 10,
            onload_loader: false,
            status_list: [
                { id: 0, name: "All" },
                { id: 1, name: "Working" },
                { id: 2, name: "Non Working" }
            ]
        };
    },
    computed: {
        filteredTableData() {
            const query = this.search.toLowerCase().trim();
            if (!query) return this.table_data;

            return this.table_data.filter(item => {
                const name = (item.employee_name || "").toLowerCase();
                const code = (item.employee_code || "").toLowerCase();
                return name.includes(query) || code.includes(query);
            });
        },
        paginatedTableData() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.filteredTableData.slice(start, end);
        }
        ,
        totalPages() {
            return Math.ceil(this.filteredTableData.length / this.itemsPerPage);
        },
    },
    methods: {
        generateAppraisalPdf() {
            try {
                const staticHeaders = [
                    { header: "Employee Code", dataKey: "employee_code" },
                    { header: "Employee Name", dataKey: "employee_name" },
                    { header: "Department", dataKey: "department" },
                    { header: "Section", dataKey: "section" },
                    { header: "Designation", dataKey: "designation" },
                    { header: "Performance Measurement Score", dataKey: "performanceMeasurementScore" },
                ];

                const dynamicHeaders = this.appraisalEvaluationParameter_list.map(param => ({
                    header: param.name,
                    dataKey: `param_${param.id}`,
                }));

                const trailingHeaders = [
                    { header: "Credit", dataKey: "credit" },
                    { header: "Total Score", dataKey: "total_score" },
                    { header: "Percentage", dataKey: "percentage" },
                ];

                const allColumns = [...staticHeaders, ...dynamicHeaders, ...trailingHeaders];

                const exportData = this.table_data.map(item => {
                    const row = {
                        employee_code: item.employee_code,
                        employee_name: item.employee_name,
                        department: item.department,
                        section: item.section,
                        designation: item.designation,
                        performanceMeasurementScore: `${item.performanceMeasurementScore !== null ? item.performanceMeasurementScore : "-"} / ${this.total_marks_by_type}`,
                        credit: (Array.isArray(item.FacultyAppraisalCreditMarks) && item.FacultyAppraisalCreditMarks.length > 0)
                            ? `${item.FacultyAppraisalCreditMarks[0]} / ${item.FacultyAppraisalCreditMarks[1]}`
                            : "0 / 0",
                        total_score: `${item.total_score.toFixed(2)} / ${item.out_of_mark_total}`,
                        percentage: item.percentage.toFixed(2),
                    };

                    this.appraisalEvaluationParameter_list.forEach(param => {
                        const score = item.facultyAppraisalOtherScore_list.find(s => s.id === param.id) || {};
                        row[`param_${param.id}`] = `${score.obtained_marks || "-"} / ${score.max_marks || "-"}`;
                    });

                    return row;
                });

                const head = [allColumns.map(c => c.header)];

                const doc = new jsPDF({ orientation: "landscape" });

                doc.autoTable({
                    head: head,
                    body: exportData,
                    columns: allColumns,
                    theme: "grid",
                    margin: { top: 10, right: 5, bottom: 5, left: 5 },
                    styles: {
                        fontSize: 7,
                        cellPadding: 0.7,
                        halign: "center",
                        valign: "middle",
                        overflow: "linebreak",
                    },
                    headStyles: {
                        fillColor: [41, 128, 185],
                        textColor: [255, 255, 255],
                        fontSize: 6,
                        halign: "center",
                        valign: "middle",
                        lineWidth: 0.2,
                        lineColor: [255, 255, 255],
                    },
                });

                doc.save("facultyAppraisalReport.pdf");
            } catch (err) {
                console.error("PDF generation error:", err);
                this.showSnackbar("error", "Failed to generate appraisal PDF");
            }
        },

        exportToExcel() {
            if (!Array.isArray(this.table_data) || this.table_data.length === 0) {
                this.showSnackbar("red", "No data to export");
                return;
            }

            const aoa = [];

            const headerRow = [
                'Employee Code',
                'Employee Name',
                'Department',
                'Section',
                'Designation',
                'Performance Measurement Score (Average of Level 2 & Level 3)'
            ];

            this.appraisalEvaluationParameter_list.forEach(param => {
                headerRow.push(param.name);
            });

            headerRow.push('Credit', 'Total Score', 'Percentage');
            aoa.push(headerRow);

            this.table_data.forEach(row => {
                const dataRow = [
                    row.employee_code,
                    row.employee_name,
                    row.department,
                    row.section,
                    row.designation,
                    `${row.performanceMeasurementScore !== null ? row.performanceMeasurementScore : "-"} / ${this.total_marks_by_type}`
                ];

                this.appraisalEvaluationParameter_list.forEach(param => {
                    const match = row.facultyAppraisalOtherScore_list.find(score => score.id === param.id) || {};
                    dataRow.push(`${match.obtained_marks || '-'} / ${match.max_marks || '-'}`);
                });

                const credit = Array.isArray(row.FacultyAppraisalCreditMarks) && row.FacultyAppraisalCreditMarks.length > 0
                    ? `${row.FacultyAppraisalCreditMarks[0]} / ${row.FacultyAppraisalCreditMarks[1]}`
                    : '0 / 0';

                dataRow.push(credit);
                dataRow.push(`${row.total_score.toFixed(2)} / ${row.out_of_mark_total}`);
                dataRow.push(row.percentage.toFixed(2));

                aoa.push(dataRow);
            });

            const worksheet = XLSX.utils.aoa_to_sheet(aoa);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'FacultyReport');
            XLSX.writeFile(workbook, 'Faculty_Performance_Report.xlsx');
        },

        onLoad() {
            this.onload_loader = true;
            axios.post("AppraisalReport/getAyAndDepartment").then((res) => {
                if (res.data.msg == "200") {
                    this.ay_list = res.data.ay_list;
                    this.department_list = res.data.department_list;
                    this.designation_list = res.data.designation_list;
                    this.onload_loader = false;
                } else {
                    this.showSnackbar("red", res.data.msg);
                    this.onload_loader = false;
                }
                this.onload_loader = false;
            });
        },

        onChangeAy() {
            this.selected_dept = "",
                this.selected_designation = "",
                this.selected_inst = [],
                this.table_data = [],
                this.inst_list = []
        },

        getInstructors() {
            const data = {
                selected_ay: this.selected_ay,
                selected_dept: this.selected_dept,
                selected_designation: this.selected_designation,
                selected_section: this.selected_section,
                selected_status: this.selected_status
            }
            this.selected_inst = [];
            this.selected_all_employee = false;
            this.selected_section = "";
            axios.post("AppraisalReport/getInstructorListByDeptDesignationAndSection", data).then((res) => {
                if (res.data.msg == "200") {
                    this.inst_list = res.data.inst_list;
                } else {
                    this.showSnackbar("red", res.data.msg);
                    this.inst_list = [];
                }
            });
        },

        getDesignation() {
            const data = {
                selected_dept: this.selected_dept,
            }
            this.selected_inst = [];
            this.selected_all_employee = false;
            this.section_list = [];
            this.selected_section = "";
            axios.post("AppraisalReport/getDesignationListByDepartment", data).then((res) => {
                if (res.data.msg == "200") {
                    this.designation_list = res.data.designation_list;

                    this.designation_list = [
                        { name: "All", id: 0 },
                        ...res.data.designation_list
                    ];
                } else {
                    this.showSnackbar("error", res.data.msg);
                    this.designation_list = [];
                    this.selected_designation = "";
                    this.section_list = [];
                    this.selected_section = "";
                }
            });
        },

        getSection() {
            const data = {
                selected_dept: this.selected_dept,
                selected_designation: this.selected_designation,
            }
            this.selected_inst = [];
            this.selected_all_employee = false;
            axios.post("AppraisalReport/getEmployeeSectionListByDeptAndDesignation", data).then((res) => {
                if (res.data.msg == "200") {
                    // this.section_list = res.data.section_list;
                    this.section_list = [
                        { name: "All", id: 0 },
                        ...res.data.section_list
                    ];
                } else {
                    this.showSnackbar("error", res.data.msg);
                    this.section_list = [];
                    this.selected_section = "";
                }
            });
        },

        toggle_teacher() {
            this.$nextTick().then(() => {
                if (this.selected_all_employee) {
                    this.selected_inst = [];
                    for (var x in this.inst_list) {
                        this.selected_inst.push(this.inst_list[x].id);
                    }

                } else {
                    this.selected_inst = [];
                }
            });
        },

        fetchReport() {
            const data = {
                selected_ay: this.selected_ay,
                selected_inst: this.selected_inst,
            }
            this.loader = true;
            axios.post("AppraisalReport/getFacultyPerformanceReport", data).then((res) => {
                if (res.data.msg == "200") {
                    this.appraisalEvaluationParameter_list = res.data.appraisalEvaluationParameter_list;
                    this.table_data = res.data.table_data;
                    this.total_marks_by_type = res.data.total_marks_by_type;
                    this.out_of_mark_total = res.data.out_of_mark_total;
                    this.loader = false;
                } else {
                    this.showSnackbar("error", res.data.msg);
                    this.loader = false;
                }
                this.loader = false;
            });

        },

        fnExcelReport(id, name) {
            this.$nextTick(() => {
                const divToExport = document.getElementById(id);
                if (!divToExport) return;
                const clonedDiv = divToExport.cloneNode(true);
                clonedDiv.querySelectorAll("img").forEach((img) => img.remove());
                clonedDiv.querySelectorAll(".no-export").forEach((el) => el.remove());
                clonedDiv
                    .querySelectorAll(".v-data-footer")
                    .forEach((el) => el.remove());

                const html = `
                    <html>
                        <head>
                        <meta charset="UTF-8">
                        <style>
                            table, th, td { border: 1px solid black; border-collapse: collapse; }
                            th, td { padding: 5px; text-align: center; }
                        </style>
                        </head>
                        <body>${clonedDiv.innerHTML}</body>
                    </html>`;

                const blob = new Blob([html], {
                    type: "application/vnd.ms-excel",
                });

                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = name + ".xls";
                a.click();
                URL.revokeObjectURL(url);
            });
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },

    mounted() {
        this.onLoad();

    },
};
</script>

<style scoped>
.teacher-appraisal-table th,
.teacher-appraisal-table td {
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
    border: 1px solid lightgray;
    font-size: 13px;
}

.teacher-appraisal-table th {
    background-color: #E8EAF6;
}
</style>
